import type {
  AddFieldNameScope,
  AddFieldPlacementTarget
} from '@cli-types/core-engine/add-field.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { ensureSchemaChildFields } from './ensure-schema-child-fields.js'
import { ensureSlotFields } from './ensure-slot-fields.js'
import { ensureTabFields } from './ensure-tab-fields.js'
import { readSchemaSlotFields } from './read-schema-slot-fields.js'

export function collectSchemaNestedTargets(
  fields: SchemaField[],
  pathPrefix: string,
  scope: AddFieldNameScope,
  targets: AddFieldPlacementTarget[]
): void {
  for (const field of fields) {
    const fieldPath = `${pathPrefix}.${field.name || field.type}`
    if (field.type === 'group' || field.type === 'section' || field.type === 'list') {
      const childScope: AddFieldNameScope = field.type === 'list' ? 'list-item' : scope
      targets.push({
        id: `${fieldPath}.fields`,
        label: `${fieldPath}.fields`,
        scope: childScope,
        getFields: () => ensureSchemaChildFields(field)
      })
      collectSchemaNestedTargets(field.fields ?? [], fieldPath, childScope, targets)
    }

    if (field.type === 'tabs' && field.tabs) {
      for (const tab of field.tabs) {
        const tabPath = `${fieldPath}.tabs.${tab.name}`
        if (tab.slot) {
          targets.push({
            id: `${tabPath}.slot:main`,
            label: `${tabPath}.slot.main.fields`,
            scope,
            getFields: () => ensureSlotFields(tab, 'main')
          })
          targets.push({
            id: `${tabPath}.slot:sidebar`,
            label: `${tabPath}.slot.sidebar.fields`,
            scope,
            getFields: () => ensureSlotFields(tab, 'sidebar')
          })
          collectSchemaNestedTargets(readSchemaSlotFields(tab.slot), tabPath, scope, targets)
        } else {
          targets.push({
            id: `${tabPath}.fields`,
            label: `${tabPath}.fields`,
            scope,
            getFields: () => ensureTabFields(tab)
          })
          collectSchemaNestedTargets(tab.fields ?? [], tabPath, scope, targets)
        }
      }
    }
  }
}
